var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystoreBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.46 22.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "playstore-badge-a",
    x1: 11.06,
    y1: -645.7,
    x2: 2.54,
    y2: -654.21,
    gradientTransform: "matrix(1 0 0 -1 0 -640.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4997d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4a98d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#45b9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#44c6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#57c8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5dc9e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playstore-badge-b",
    x1: 17.16,
    y1: -651.42,
    x2: 4.89,
    y2: -651.42,
    gradientTransform: "matrix(1 0 0 -1 0 -640.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcdf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fbbc16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f9a41b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89a1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playstore-badge-c",
    x1: 12.59,
    y1: -652.59,
    x2: 1.05,
    y2: -664.14,
    gradientTransform: "matrix(1 0 0 -1 0 -640.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee414a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c21e63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playstore-badge-d",
    x1: 3.7,
    y1: -641.37,
    x2: 8.86,
    y2: -646.52,
    gradientTransform: "matrix(1 0 0 -1 0 -640.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#309f73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2ba672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4cb970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#60bc6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66be6b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.94 22.44H2.53A2.65 2.65 0 010 19.7V3.2A2.65 2.65 0 012.53.46h63.4a2.65 2.65 0 012.53 2.74v16.5a2.63 2.63 0 01-2.52 2.74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.94.45a2.27 2.27 0 012.13 2.4V20a2.27 2.27 0 01-2.13 2.4H2.53A2.27 2.27 0 01.4 20V2.87A2.27 2.27 0 012.53.47h63.41m0-.47H2.53A2.71 2.71 0 000 2.85V20a2.71 2.71 0 002.53 2.85h63.4A2.71 2.71 0 0068.46 20V2.87A2.7 2.7 0 0065.94 0z",
    fill: "#a2b3d1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.05 6.13a1.37 1.37 0 01-.37 1 1.48 1.48 0 01-1.13.46A1.57 1.57 0 0121 6a1.57 1.57 0 011.58-1.59 1.38 1.38 0 01.63.14 1.32 1.32 0 01.48.33l-.26.27a1 1 0 00-.83-.36 1.09 1.09 0 00-.83.33 1.19 1.19 0 00-.35.88 1.2 1.2 0 00.35.89 1.09 1.09 0 00.83.33 1.14 1.14 0 00.85-.33 1 1 0 00.26-.62h-1.14v-.36H24v.22zm2.34-1.28H25v1h1.25v.36H25v1h1.39v.38h-1.78v-3h1.78zM28 7.53h-.39V4.85h-.81v-.37h2.08v.37H28v2.68zm2.36 0v-3h.38v3zm2.12 0h-.38V4.85h-.86v-.37h2.09v.37h-.86v2.68zm4.82-.4a1.46 1.46 0 01-1.11.45 1.47 1.47 0 01-1.11-.45 1.66 1.66 0 010-2.25 1.47 1.47 0 011.11-.45 1.5 1.5 0 011.11.46A1.58 1.58 0 0137.8 6a1.64 1.64 0 01-.46 1.13zm-2-.26a1.11 1.11 0 00.83.35 1.13 1.13 0 00.83-.35 1.15 1.15 0 00.42-.87 1.18 1.18 0 00-.33-.87 1.16 1.16 0 00-.83-.34 1.14 1.14 0 00-.83.34 1.19 1.19 0 00-.34.87 1.2 1.2 0 00.34.87zm2.94.66v-3h.48l1.58 2.32h0V4.48h.39v3h-.4L38.72 5h0v2.53z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.56 12a2.16 2.16 0 102.17 2.16A2.13 2.13 0 0034.56 12zm0 3.47a1.32 1.32 0 111.22-1.31 1.25 1.25 0 01-1.22 1.27zM29.83 12A2.16 2.16 0 1032 14.12 2.13 2.13 0 0029.83 12zm0 3.47a1.32 1.32 0 111.22-1.31 1.25 1.25 0 01-1.22 1.27zm-5.62-2.8v.91h2.2a1.92 1.92 0 01-.5 1.15 2.22 2.22 0 01-1.68.67 2.44 2.44 0 010-4.87 2.3 2.3 0 011.64.65l.64-.64a3.18 3.18 0 00-2.3-.92 3.35 3.35 0 100 6.69 3 3 0 002.34-.94 3 3 0 00.79-2.14 2.47 2.47 0 00-.05-.57zm23 .71A2 2 0 0045.35 12a2.05 2.05 0 00-2 2.16 2.11 2.11 0 002.14 2.15 2.14 2.14 0 001.8-.95l-.74-.5a1.2 1.2 0 01-1.06.61 1.08 1.08 0 01-1-.66l2.89-1.19zm-2.93.72a1.19 1.19 0 011.13-1.26.85.85 0 01.8.46zm-2.35 2.09h1V9.81h-1zm-1.56-3.71a1.52 1.52 0 00-1.18-.48 2.16 2.16 0 000 4.32 1.47 1.47 0 001.14-.49v.31c0 .83-.44 1.27-1.15 1.27a1.21 1.21 0 01-1.08-.76l-.83.34a2 2 0 001.91 1.27 2 2 0 002-2.24v-3.91h-.9zm-1.08 3a1.31 1.31 0 010-2.61 1.22 1.22 0 011.15 1.31 1.21 1.21 0 01-1.17 1.25zm12.35-5.67h-2.27v6.34h1v-2.4h1.32a2 2 0 100-3.94zm0 3.06h-1.33V10.7h1.35a1.09 1.09 0 110 2.17zm5.87-.87a1.77 1.77 0 00-1.68 1l.84.35a1 1 0 011.86.34v.07a2.21 2.21 0 00-1-.24c-.91 0-1.83.49-1.83 1.43a1.45 1.45 0 001.58 1.39 1.31 1.31 0 001.2-.61v.49h.91v-2.49A1.73 1.73 0 0057.51 12zm-.12 3.47c-.31 0-.73-.16-.73-.54s.53-.68 1-.68a1.74 1.74 0 01.87.21 1.17 1.17 0 01-1.14.97zm5.37-3.34l-1.08 2.75-1.13-2.75h-1l1.68 3.85-1 2.14h1l2.6-6zm-8.51 4.06h1V9.81h-1z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29 4.76a1 1 0 00-.24.71v11.22a1 1 0 00.24.7l6.29-6.27V11L5.33 4.71z",
    fill: "url(#playstore-badge-a)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 13.25l-2.09-2.11V11l2.1-2.1 2.48 1.41a.77.77 0 010 1.46l-2.49 1.43z",
    fill: "url(#playstore-badge-b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.76 13.22l-2.14-2.14-6.32 6.31a.81.81 0 001.06 0l7.4-4.2",
    fill: "url(#playstore-badge-c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.76 8.94L6.34 4.72a.84.84 0 00-1 0l6.31 6.31z",
    fill: "url(#playstore-badge-d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.71 13.18l-7.37 4.19a.85.85 0 01-1 0 .85.85 0 001 0l7.42-4.22z",
    fill: "#010101",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29 17.33a1 1 0 01-.24-.71v.08a1 1 0 00.24.71zm10.95-5.6l-2.53 1.44v.05l2.48-1.41a.91.91 0 00.53-.73.91.91 0 01-.48.65z",
    fill: "#010101",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34 4.8l9.9 5.62a1 1 0 01.53.66.88.88 0 00-.53-.74l-9.9-5.62c-.71-.4-1.28-.07-1.28.75v.08c0-.82.57-1.15 1.28-.75z",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreBadge);
export default __webpack_public_path__ + "static/media/playstore-badge.250bc5be1f49aa59858dbb1b1c25f91f.svg";
export { ForwardRef as ReactComponent };